(function() {

  'use strict';

  angular.module('operiaChat.chat', [
    'moteur/composants/operiaChat/operiaChat.html',
    'moteur/composants/operiaVideo/operiaVideo.html'
  ]);

})();